import React from 'react';

import { ReportingFlow } from '../ReportingFlow';

export const ReportPage = () => <ReportingFlow />;
